import styles from "./Galerie.module.css";

import galerie1 from "../../assets/images/Galerie/galerie1.avif";
import galerie2 from "../../assets/images/Galerie/galerie2.avif";
import galerie3 from "../../assets/images/Galerie/galerie3.avif";

const images = [galerie2, galerie1, galerie3];

function Galerie() {
  return (
    <div className={styles.galleryWrapper}>
      <div className={styles.galleryContainer}>
        {images.map((image, index) => (
          <div className={styles.galleryItem} key={index}>
            <img
              src={image}
              alt={`Bild ${index + 1}`}
              className={styles.galleryImage}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Galerie;
